/*
 * File: /src/router/routes/contentBlocks.js
 * Created Date: Saturday November 14th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 14th November 2020 8:55:51 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

const ContentBlockList = () =>
  import(/* webpackChunkName: "ContentBlockList" */ 'src/components/Dashboard/Views/ContentBlocks/ContentBlockList.vue');

const ContentBlockEdit = () =>
  import(/* webpackChunkName: "ContentBlockEdit" */ 'src/components/Dashboard/Views/ContentBlocks/ContentBlockEdit.vue');
export const contentBlockRoutes = [
  {
    path: 'content-blocks/add/',
    name: 'Add Quick Reply',
    component: ContentBlockEdit,
  },

  {
    path: 'content-blocks/edit/:id',
    name: 'Edit Quick Reply',
    component: ContentBlockEdit,
  },
  {
    path: 'content-blocks/list/',
    name: 'List Quick Replies',
    component: ContentBlockList
  }
];
